import { render } from "./mailInbox.vue?vue&type=template&id=7ed92092"
import script from "./mailInbox.vue?vue&type=script&lang=js"
export * from "./mailInbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__